import styled from '@emotion/styled';
import { ComponentProps, FC } from 'react';
import { IconCheck16 } from 'components/base/Icon';
import Text from 'components/base/Text';
import { white } from 'styles';
import { intToHex } from 'util/colors';
import { numberwithComma } from 'util/number';

const MAX_COUNT = 9_999;

type ColorListItem = {
  name: string;
  image_url: string;
  text_color: number;
  selected: boolean;
  count: number;
};

interface Props {
  color_item: ColorListItem;
  onColorClick?: (color_name: string, selected: boolean) => void;
}

/**
 * 검색 필터 - 색상 필터 Item
 * @component
 */
const ColorItem: FC<Props> = ({ color_item, onColorClick }) => {
  const { count, name, selected, image_url, text_color } = color_item;
  const display_count = numberwithComma(count, { max_count: MAX_COUNT, max_count_subfix: '+' });
  const check_icon_color = intToHex(text_color);

  const handleColorClick = () => {
    onColorClick?.(name, selected);
  };

  const is_white = name === '화이트';

  const text_style: ComponentProps<typeof Text> = selected
    ? { variant: 'title5_medium', color: 'gray_active' }
    : { variant: 'body2', color: 'gray_inactive' };

  return (
    <SC.Container onClick={handleColorClick}>
      <SC.Color>
        <SC.ColorImg src={image_url} is_show_border={is_white} />
        {selected && <IconCheck16 color={check_icon_color} />}
      </SC.Color>
      <Text {...text_style} as='p' alignment='center'>
        {name}
      </Text>
      <Text variant='body4_regular' color='gray_tertiary' as='p' alignment='center'>
        {display_count}
      </Text>
    </SC.Container>
  );
};

export default ColorItem;

const SC = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
  `,
  Color: styled.div`
    position: relative;

    > svg {
      position: absolute;
      top: 6px;
      left: 6px;
    }
  `,
  ColorImg: styled.img<{ is_show_border?: boolean }>`
    width: 28px;
    height: 28px;
    border-radius: 28px;
    margin-bottom: 6px;
    border: 1px solid ${({ is_show_border }) => (is_show_border ? 'rgba(0, 0, 0, 0.05)' : white)};
  `,
};
